export const COMETCHAT_CONSTANTS = {
	APP_ID: process.env.REACT_APP_COMETCHAT_APP_ID,
	REGION: process.env.REACT_APP_COMETCHAT_REGION,
	AUTH_KEY: process.env.REACT_APP_COMETCHAT_AUTH_KEY
}